import DocumentTypeEnum from '../../../../../Spirit/Entities/Enums/DocumentTypeEnum';
import DocumentTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/DocumentService/DocumentTranslationResponse';

export default class DocumentUpdateRequest  {
	Id: DocumentTypeEnum = null;
	Translations: Array<DocumentTranslationResponse> = null;
	constructor(obj?: Partial<DocumentUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
